import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo-gray.svg';
import _imports_1 from '@/assets/icon/arrow-right-white.svg';
import _imports_2 from '@/assets/icon/icon-twitter-default.svg';
import _imports_3 from '@/assets/icon/icon-twitter-primary.svg';
import _imports_4 from '@/assets/icon/icon-facebook-default.svg';
import _imports_5 from '@/assets/icon/icon-facebook-primary.svg';
import _imports_6 from '@/assets/icon/icon-ig-default.svg';
import _imports_7 from '@/assets/icon/icon-ig-primary.svg';
import _imports_8 from '@/assets/icon/icon-youtube-default.svg';
import _imports_9 from '@/assets/icon/icon-youtube-primary.svg';
import _imports_10 from '@/assets/icon/icon-medium-default.svg';
import _imports_11 from '@/assets/icon/icon-medium-primary.svg';
import _imports_12 from '@/assets/icon/icon-arrow-up-right-white.svg';
import _imports_13 from '@/assets/logo-incubated-by-bincentive-gray.svg';
import _imports_14 from '@/assets/icon/icon-arrow-up-white.svg';

const _withScopeId = n => (_pushScopeId("data-v-2293950e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-container"
};
const _hoisted_2 = {
  class: "wrapper"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "contact-container"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-wrapper tablet-hidden"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "investNFT"
})], -1));

const _hoisted_6 = {
  class: "contact-us-wrapper"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Contact us", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2 email"
}, "support@investnft.finance", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "arrow-right"
}, null, -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];

const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"media-container\" data-v-2293950e><a href=\"https://twitter.com/investnft_fin\" target=\"_blank\" data-v-2293950e><div class=\"icon-rounded-wrapper\" data-v-2293950e><img class=\"normal\" src=\"" + _imports_2 + "\" alt=\"web\" data-v-2293950e><img class=\"hover\" src=\"" + _imports_3 + "\" alt=\"web\" data-v-2293950e></div></a><a href=\"https://www.facebook.com/InvestNFT-103191779014575\" target=\"_blank\" data-v-2293950e><div class=\"icon-rounded-wrapper\" data-v-2293950e><img class=\"normal\" src=\"" + _imports_4 + "\" alt=\"web\" data-v-2293950e><img class=\"hover\" src=\"" + _imports_5 + "\" alt=\"web\" data-v-2293950e></div></a><a href=\"https://www.instagram.com/investnft.finance/\" target=\"_blank\" data-v-2293950e><div class=\"icon-rounded-wrapper\" data-v-2293950e><img class=\"normal\" src=\"" + _imports_6 + "\" alt=\"web\" data-v-2293950e><img class=\"hover\" src=\"" + _imports_7 + "\" alt=\"web\" data-v-2293950e></div></a><a href=\"https://www.youtube.com/channel/UCtrMP6rIB0xOzL3ut20bd2Q\" target=\"_blank\" data-v-2293950e><div class=\"icon-rounded-wrapper\" data-v-2293950e><img class=\"normal\" src=\"" + _imports_8 + "\" alt=\"web\" data-v-2293950e><img class=\"hover\" src=\"" + _imports_9 + "\" alt=\"web\" data-v-2293950e></div></a><a href=\"https://medium.com/@investnft.finance\" target=\"_blank\" data-v-2293950e><div class=\"icon-rounded-wrapper\" data-v-2293950e><img class=\"normal\" src=\"" + _imports_10 + "\" alt=\"web\" data-v-2293950e><img class=\"hover\" src=\"" + _imports_11 + "\" alt=\"web\" data-v-2293950e></div></a></div>", 1);

const _hoisted_12 = {
  class: "info-container"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-wrapper desktop-hidden-tablet"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "investNFT"
})], -1));

const _hoisted_14 = {
  class: "info-wrapper"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Resources", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 value"
}, "GitBook ", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "out"
}, null, -1));

const _hoisted_18 = [_hoisted_16, _hoisted_17];

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 value"
}, "Hotpot.Finance ", -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "out"
}, null, -1));

const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = {
  class: "info-wrapper"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Company", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 value"
}, "Privacy Policy ", -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "out"
}, null, -1));

const _hoisted_26 = [_hoisted_24, _hoisted_25];

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-caption1 value"
}, "User Agreement ", -1));

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "out"
}, null, -1));

const _hoisted_29 = [_hoisted_27, _hoisted_28];
const _hoisted_30 = {
  class: "terms-wrapper"
};
const _hoisted_31 = {
  class: "block"
};

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "incubated-by"
}, null, -1));

const _hoisted_33 = [_hoisted_32];

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "term-wrapper"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-caption2"
}, "© 2022 Bincentive Inc. All Rights Reserved.")], -1));

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-button1"
}, "TOP", -1));

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: "top"
}, null, -1));

const _hoisted_37 = [_hoisted_35, _hoisted_36];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", {
    class: "email-wrapper cursor",
    onClick: _cache[0] || (_cache[0] = $event => $options.externalLink('mailto:support@investnft.finance'))
  }, _hoisted_10), _hoisted_11])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", {
    class: "value-wrapper cursor",
    onClick: _cache[1] || (_cache[1] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/'))
  }, _hoisted_18), _createElementVNode("div", {
    class: "value-wrapper cursor",
    onClick: _cache[2] || (_cache[2] = $event => $options.externalLink('https://hotpot.finance/?utm_source=investnft&utm_medium=landing_page&utm_campaign=hyperlink'))
  }, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", {
    class: "value-wrapper cursor",
    onClick: _cache[3] || (_cache[3] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/regulations/privacy-policy'))
  }, _hoisted_26), _createElementVNode("div", {
    class: "value-wrapper cursor",
    onClick: _cache[4] || (_cache[4] = $event => $options.externalLink('https://investnft.gitbook.io/investnft/terms-and-conditions/terms-of-service'))
  }, _hoisted_29)])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
    class: "term-wrapper cursor logo",
    onClick: _cache[5] || (_cache[5] = $event => $options.externalLink('https://bit.ly/3JMtrQ1'))
  }, _hoisted_33), _hoisted_34]), _createElementVNode("div", {
    class: "block cursor",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.toTop && $options.toTop(...args))
  }, _hoisted_37)])])]);
}